import React, { CSSProperties, useState } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import styles from './index.module.scss';

export interface FloatingMoreAction {
  key: string;
  label: string;
  onClick: () => void;
}

interface FloatingMoreActionsProps {
  actions: FloatingMoreAction[];
  className?: string;
  rootRef?: React.RefObject<HTMLDivElement>;
}

const FloatingMoreActions: React.FC<FloatingMoreActionsProps> = ({ actions, className, rootRef }) => {
  const [open, setOpen] = useState(false);
  const container = document.getElementById('full_screen_box') ?? document.body;

  return createPortal(
    <div
      ref={rootRef}
      className={classNames(styles.moreActions, open && styles.moreActionsOpen, className)}
      onMouseLeave={() => setOpen(false)}
    >
      <div
        role="button"
        tabIndex={0}
        className={styles.trigger}
        onClick={() => setOpen(true)}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setOpen(true);
          }
        }}
        aria-expanded={open}
        aria-label="更多功能"
      >
        <span>更</span>
        <span>多</span>
        <span>功</span>
        <span>能</span>
      </div>
      <div className={styles.menu}>
        {actions.map((action, index) => (
          <button
            key={action.key}
            type="button"
            className={styles.actionBtn}
            style={{ '--action-index': index } as CSSProperties}
            onClick={() => {
              action.onClick();
              setOpen(false);
            }}
          >
            {action.label}
          </button>
        ))}
      </div>
    </div>,
    container
  );
};

export default FloatingMoreActions;
